import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'
import Vue from 'vue'

export default function Campaigns() {
  const route = 'campaign'
  const campaign = ref({
    from: Vue.prototype.$auth.first_name,
    status: 1,
  })

  const formattedCampaign = computed(() => ({
    name: campaign.value.name,
    subject: campaign.value.subject,
    body: campaign.value.body,
    from: campaign.value.from,
    status: campaign.value.status,
    events: campaign.value.events.map(event => event.id),
    emails: campaign.value.attendees?.map(attendee => attendee.email),
    header: campaign.value.header?.id,
  }))

  const indexRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const showRequest = (id, params) => jwt.axiosIns.get(`${route}/${id}`, { params }).then(res => res).catch(() => [])

  const storeRequest = () => jwt.axiosIns.post(route, formattedCampaign.value).then(res => res)

  const sendRequest = () => jwt.axiosIns.post(`${route}/send/${campaign.value.id}`,
    {
      organization_id: Vue.prototype.$orgId,
      events: formattedCampaign.value.events,
      emails: formattedCampaign.value.emails,
    }).then(res => res)

  const updateRequest = () => jwt.axiosIns.put(`${route}/${campaign.value.id}`, formattedCampaign.value).then(res => res)

  const publishRequest = () => jwt.axiosIns.post(`${route}/${campaign.value.id}/publish`).then(res => res)

  const destroyRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    campaign, indexRequest, showRequest, storeRequest, sendRequest, updateRequest, publishRequest, destroyRequest,
  }
}
